import React from 'react';
import {
  Container, Row, Col, Tab, Nav,
} from 'react-bootstrap';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import { Template } from '../template/index';
import { UsersList } from './UsersList';
import { UserPainel } from './UserPainel';
import { UsersPanelList } from './UsersPanelList';
import { UserWifi } from './UserWifi';

export function UsersAdmin () {
  const history = useHistory();
  function handleGoBack () {
    history.push('/');
  }
  return (
    <Template>
      <Container className="main-updates">
        <div className="goBack">
          <FontAwesomeIcon icon={faArrowLeft} title="Voltar" size="lg" onClick={handleGoBack} />
          <h2>Gerenciar Usuários Admin</h2>
        </div>
        <hr />
        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <Row>
            <Col sm={3}>
              <Nav variant="pills" className="flex-column">
                <Nav.Item>
                  <Nav.Link eventKey="first">Usuários</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Cadastrar usuário WiFi</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Usuários Painel</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="fourth">Cadastrar usuário Painel</Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <UsersList />
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <UserWifi />
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <UsersPanelList />
                </Tab.Pane>
                <Tab.Pane eventKey="fourth">
                  <UserPainel />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </Template>
  );
}
